import { useHydrated } from '@tanstack/react-router';
import { useCallback } from 'react';

export const useLocaleDateString = () => {
    const hydrated = useHydrated();
    return useCallback(
        (date: string | number | Date) => {
            const d = new Date(date);
            return hydrated
                ? d.toLocaleDateString()
                : d.toLocaleDateString('en-US', {
                      timeZone: 'UTC',
                  });
        },
        [hydrated],
    );
};

export const useLocaleDateTimeString = () => {
    const hydrated = useHydrated();
    return useCallback(
        (date: string | number | Date) => {
            const d = new Date(date);
            return hydrated
                ? d.toLocaleString()
                : d.toLocaleString('en-US', {
                      timeZone: 'UTC',
                  });
        },
        [hydrated],
    );
};

export const useLocaleString = () => {
    const hydrated = useHydrated();
    return useCallback(
        (data: string | number) => {
            return hydrated
                ? data.toLocaleString()
                : data.toLocaleString('en-US');
        },
        [hydrated],
    );
};
